import type { DocumentStatus } from '@/lib/api';
import { Badge } from '@/components/ui/badge';

const STATUS_CONFIG: Record<DocumentStatus, { label: string; variant: 'success' | 'warning' | 'destructive' | 'info' | 'muted' | 'secondary' }> = {
	received: { label: 'Ontvangen', variant: 'muted' },
	processing: { label: 'Verwerking', variant: 'info' },
	classified: { label: 'Geclassificeerd', variant: 'info' },
	completed: { label: 'Gereed', variant: 'success' },
	error: { label: 'Fout', variant: 'destructive' },
	duplicate: { label: 'Dubbel', variant: 'warning' },
	skipped: { label: 'Overgeslagen', variant: 'muted' },
};

export function StatusBadge({ status }: { status: DocumentStatus }) {
	const cfg = STATUS_CONFIG[status] ?? { label: status, variant: 'muted' as const };
	return <Badge variant={cfg.variant}>{cfg.label}</Badge>;
}

const DOCUMENT_TYPE_LABELS: Record<string, string> = {
	invoice_incoming: 'Inkoopfactuur',
	invoice_outgoing: 'Verkoopfactuur',
	credit_note: 'Creditnota',
	reminder: 'Aanmaning',
	contract: 'Contract',
	employment_contract: 'Arbeidsovereenkomst',
	quote: 'Offerte',
	letter_incoming: 'Inkomende brief',
	letter_outgoing: 'Uitgaande brief',
	government_decision: 'Beschikking',
	insurance_claim: 'Zorgverzekeraar',
	policy: 'Polis',
	payslip: 'Loonstrook',
	annual_statement: 'Jaaropgave',
	report: 'Rapportage',
	receipt: 'Bon',
	other: 'Overig',
};

export function DocumentTypeLabel({ type }: { type: string | null | undefined }) {
	if (!type) return <span className="text-muted-foreground">—</span>;
	return <span>{DOCUMENT_TYPE_LABELS[type] ?? type}</span>;
}
